import { StaticImage } from "gatsby-plugin-image"

const entrepreneursOrganizationData = {
  color: "#ffd1d5",
  heroTitle: `How Entrepreneur’s Organization used event photos to deepen community connections`,
  heroImage: (
    <StaticImage
      src="../../images/case-study/entrepreneurs/hero.png"
      alt="eo-entrepreneurs-organization-networking-photo-ai-hero"
    />
  ),
  metrics: {
    quote: ` Table of Contents<br/><br/>
      <ul style="list-style-type: disc; padding: 0 60px; text-align: left;">
        <li style="margin-bottom: 16px;"><a href='#section-0'><b>About Entrepreneur’s Organization</b></a><br/>A look into EO’s mission, global presence, and why events are core to their community.</li>
        <li style="margin-bottom: 16px;"><a href='#section-1'><b>The Challenge: Manual photo distribution that wasn’t scalable</b></a><br/> Why traditional tools like Google Drive weren’t cutting it anymore.</li>
        <li style="margin-bottom: 16px;"><a href='#section-2'><b>The Solution: A modern, AI-powered attendee experience</b
        ></a><br/>How EO used AI-powered galleries, personalized photo walls, and social sharing to elevate attendee engagement.</li>
        <li class='mb-2'><a href='#section-3'><b>AI-powered photo distribution</b></a><br/>How EO delivered personalized, on-brand galleries to every attendee in real time.</li>
        <li class='mb-2'><a href='#section-4'><b>UGC prompts to boost social media presence</b></a><br/>The role of UGC prompts and branded content in boosting EO’s online visibility.</li>
        <li class='mb-2'><a href='#section-5'><b>The power of poster-driven promotion</b></a><br/>From posters to referrals, the easiest way to turn attendees into advocates.</li>
        <li class='mb-2'><a href='#section-6'><b>What’s next: A growing partnership</b></a><br/>From a single event to an annual subscription, what’s ahead for EO and Premagic.
</li>
      </ul>`,
  },
  //   images: [
  //     {
  //       img: (
  //         <StaticImage
  //           src="../../images/case-study/khaleej-times/hero.png"
  //           alt="Sponsors"
  //         />
  //       ),
  //     },
  //     {
  //       img: (
  //         <StaticImage
  //           src="../../images/case-study/khaleej-times/gallery.png"
  //           alt="AGC"
  //         />
  //       ),
  //     },
  //     {
  //       img: (
  //         <StaticImage
  //           src="../../images/case-study/khaleej-times/avatars.png"
  //           alt="Avatars"
  //         />
  //       ),
  //     },
  //   ],
  gallery: (
    <StaticImage
      src="../../images/case-study/entrepreneurs/collage.png"
      alt="eo-entrepreneurs-organization-networking-photo-ai-collage"
    />
  ),
  caseStudyData: [
    {
      title: "About Entrepreneur’s Organization (EO)",
      info1: `<a href='https://eonetwork.org/?scLang=en'>Entrepreneur’s Organization (EO)</a>  is a global network of over 18,000 influential business owners across 61 countries. With 220+ chapters worldwide, EO exists to help entrepreneurs grow through peer-to-peer learning, curated experiences, and real human connection. Their mission is simple: empower leading entrepreneurs to learn and grow through experiences that transform their businesses and lives.<br/><br/>Events are central to EO’s mission. They host everything from intimate board discussions and regional networking meetups to large-scale leadership summits and global conferences. Whether it's 50 people in a leadership roundtable or 800 members at a flagship summit, the common thread is a powerful connection and real conversations. In 2024-25, their events spanned across the US, Canada, Mexico, Latin America, and South America.<br/><br/>And recently, they decided to level up the attendee experience using Premagic.`,
    },
    {
      title: "The challenge: Manual photo distribution that wasn’t scalable",
      info1: `Before Premagic, EO’s photo-sharing process involved manually uploading images to a shared Google Drive and sending out links days after the event. It was time-consuming, lacked branding, and didn’t quite match the high standard of experience they wanted to deliver to their members, many of whom are successful CEOs and business owners.<br/><br/>EO wanted a solution that not only simplified photo sharing but also made it more interactive and in sync with their brand ethos of community, recognition, and visibility.`,
    },
    {
      title: "The solution: A modern, AI-powered attendee experience",
      info1: `The first touchpoint came from an EO member named Abir, who experienced Premagic at another event in Riyadh. Impressed by the seamless photo access and social media-friendly interface, she recommended it to EO’s internal team. That led to conversations with EO’s marketing director, and soon, we were powering one of their flagship events.<br/><br/>Here’s how we elevated the attendee experience:<br/><br/><b>AI-powered photo distribution</b><br/>`,
      info2: `<ul style='padding-left:20px; list-style: disc;'>
      <li><b>Personalized attendee experience:</b> Each attendee received their own private event portal featuring all their photos, curated highlights, and social-ready content designed for real-time social sharing.
        </li>
        <li><b>Face recognition–powered photo wall:</b> Premagic’s AI-powered platform automatically pulled out every photo an attendee appeared in, creating a personal gallery just for them.</li>
        <li><b>People page:</b> Attendees could also browse a mosaic of faces to quickly locate themselves or friends and access their photos.</li>
        <li><b>One-tap social sharing:</b> With editable AI-generated captions and hashtags, attendees could instantly post their photos in real-time on LinkedIn, Instagram, and more.</li>
        <li><b>EO-branded watermarking:</b> Every image carried EO branding, ensuring visual consistency and increasing brand visibility on social media.</li>
        <li><b>Segmented albums:</b> The gallery was neatly divided by day and session type, making navigation easy and memory recall effortless.</li>
      </ul>`,
      image: (
        <StaticImage
          src="../../images/case-study/entrepreneurs/Gallery.png"
          alt="eo-entrepreneurs-organization-networking-photo-ai-gallery"
        />
      ),
    },
    {
      title: "UGC prompts to boost social media presence",
      info1: `To help EO drive visibility, we set up event-specific share prompts embedded within the gallery. Attendees could post directly to LinkedIn or Instagram as soon as they received their photos with one click, complete with pre-filled copy and hashtags aligned with EO’s messaging.<br/><br/>This gave EO a consistent brand voice across user-generated content and encouraged even those who don’t usually post to participate.`,
      info2: `<a href='https://www.linkedin.com/posts/joeygoone_super-cool-to-be-in-community-with-the-midwest-activity-7323783349485895680-Wf81/?utm_source=share&utm_medium=member_desktop&rcm=ACoAAAyv43AB2SgoUYzzBw_tKdC9nckUJC8orn8'>See Post</a>`,
      //   testimonial: {
      //     img: (
      //       <StaticImage
      //         src="../../images/case-study/khaleej-times/mohammed.png"
      //         alt=""
      //       />
      //     ),
      //     message: `“It was a new idea that we implemented at Khaleej Times. And so far, everyone is so satisfied. The feedback from the audience and speakers was really amazing. So we’re looking forward to having Premagic power our future events as well.”`,
      //     name: "Mohammed Hegazy",
      //     info: ` Senior Conference Producer<br />Khaleej Times`,
      //   },
      image: (
        <StaticImage
          src="../../images/case-study/entrepreneurs/linkedin-post.png"
          alt="eo-entrepreneurs-organization-networking-photo-ai-linkedin-post"
        />
      ),
    },
    {
      title: `The power of poster-driven promotion`,
      info1: `The EO team had never deployed marketing posters at their events before, so this was a first for them. Using our pre-designed template poster maker, they set up a sleek “I am attending” poster and shared the link with their attendee list. Attendees could easily personalize and share these posters—their photos and details were automatically pulled from LinkedIn. Each poster was linked to the event’s registration page.<br/><br/>The response was immediate. Over <b>179 attendees</b> shared their posters, leading to <b>190 referrals—people</b> who clicked through to explore or register for the event. This alone generates an estimated ROI of <b>$2,177.</b>`,
      imagePosition: "center",
      image: (
        <StaticImage
          src="../../images/case-study/entrepreneurs/Posters.png"
          alt="eo-entrepreneurs-organization-networking-photo-ai-posters"
        />
      ),
    },
    {
      title: `What’s next: A growing partnership`,
      info1: `This was just the beginning.<br/><br/>What started as a single-event collaboration has now evolved into an annual subscription. EO plans to use Premagic across multiple global events throughout the year, from leadership summits to more intimate networking sessions.`,
      info2: `We’re working closely with their team to explore:<br/><ul style='list-style: disc; padding-left:20px'><li>Extended use of advocacy tools</li><li>Customized branding across regions</li><li>Insights reporting and engagement tracking</li><li>Deeper integrations with their community platform
</li></ul><br/><br/><b>Want your event photos to do more than just sit in a folder?</b> Let’s talk about how your photos can help drive community, visibility, and connection.
`,
      imagePosition: "center",
    },
  ],
  isCTAActive: true,
}

export default entrepreneursOrganizationData
